// Create a new file: src/context/MembershipContext.js
import React, { createContext, useState, useEffect } from 'react';

const MembershipContext = createContext();

export const MembershipProvider = ({ children }) => {
  const [activeTab, setActiveTab] = useState('plans');

  return (
    <MembershipContext.Provider value={{ activeTab, setActiveTab }}>
      {children}
    </MembershipContext.Provider>
  );
};

export default MembershipContext;